module.exports = __webpack_public_path__ + "static/assets/d527a686da1975e039bf23e523bf1987.png";